import { useState, useMemo, useEffect } from "react";

/**
 * Client-side pagination for lists fetched in full from the backend (no
 * server paging support). Slices `items` into pages of `pageSize`; resets to
 * page 0 whenever the list shrinks below the current page.
 */
export function useClientPagination<T>(items: T[], pageSize = 20) {
  const [page, setPage] = useState(0);
  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));

  useEffect(() => {
    if (page > totalPages - 1) setPage(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalPages]);

  const rows = useMemo(
    () => items.slice(page * pageSize, page * pageSize + pageSize),
    [items, page, pageSize],
  );

  return { rows, page, setPage, totalPages };
}
